import {Outlet, useMatch} from "react-router";
import ManagementWorkspace from "@/components/management/ManagementWorkspace.tsx";
import CharacterListPanel from "@/characters/CharacterListPanel.tsx";

export default function CharacterWorkspace() {
    const createMatch = useMatch("/campaigns/:campaignSlug/characters/new");
    const detailMatch = useMatch("/campaigns/:campaignSlug/characters/:id");
    const editMatch = useMatch("/campaigns/:campaignSlug/characters/:id/edit");
    const selectedId = createMatch ? undefined : editMatch?.params.id ?? detailMatch?.params.id;

    return (
        <ManagementWorkspace sidebar={<CharacterListPanel selectedId={selectedId}/> }>
            <Outlet/>
        </ManagementWorkspace>
    );
}
